import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

const sourceGenerationRoutes = [
	{
		component: LazyComponent(lazy(() => import('./Create'))),
		path: '/source-generation/create',
	},
	{
		component: LazyComponent(lazy(() => import('./Update'))),
		path: '/source-generation/update/:id',
	},
];

export default sourceGenerationRoutes;
